import {AfterViewInit, Component, HostListener, OnInit, Renderer2} from '@angular/core';
import {LbChartHeaderComponent} from '../lb-chart-header/lb-chart-header.component';
import {ViewChild} from '@angular/core';
import {ElementRef} from '@angular/core';
import * as Plotly from 'plotly.js-dist-min'
import {Input} from '@angular/core';
import {RxAuthService} from "../../../../services/rx-auth/rx-auth.service";
import {HttpClient} from "@angular/common/http";
import {ChartsCommonFunctions} from "../../../../shared/toolbox/charts/chartsCommonFunctions";
import {ListProfileComponent} from "../../../../profiles/list-profile/list-profile.component";
import {RetailerProfileComponent} from "../../../../profiles/retailer-profile/retailer-profile.component";
import {ActivatedRoute} from "@angular/router";
import {ChartWrapperComponent} from "../../../../shared/toolbox/charts/chart-wrapper/chart-wrapper.component";


@Component({
  standalone: true,
  selector: 'app-lb-pie-chart',
  templateUrl: './lb-pie-chart.component.html',
  styleUrls: ['./lb-pie-chart.component.scss'],
  imports: [
    LbChartHeaderComponent
  ]
})
export class LbPieChartComponent implements OnInit, AfterViewInit {

  palette = ['#3792BF', '#1B3E78', '#AACCFF', '#BDBDBD', '#7D7979', '#0CAD99'];


  @ViewChild('plotContainer', {static: true}) plotContainer!: ElementRef;
  @Input() data: any = null;

  @Input() text_elements: any = {
    header: 'Preferred metrics',
    subheader: 'Metrics used to measure consumer demand',
    caption: 'Caption',
  }

  @Input() isEditMode: boolean = false;

  @ViewChild('chartContainer', {static: true}) chartContainer!: ElementRef;

  plotId = 'plotId'
  plotlyChart: any = null
  originalChart: any = null


  constructor(private common: ChartsCommonFunctions) {
  }

  chartData: any = {
    data: [
      {
        labels: ['Sales', 'Search Demand', 'Market Share', 'NPS Score', 'Traffic'], // x-axis data for first trace
        values: [1, 3, 2, 4, 5], // y-axis data for first trace
        hole: .35,
        type: 'pie',
        insidetextorientation: 'horizontal',

        marker: {
          colors: this.palette
        },
        //textinfo: 'none',
        hoverinfo: 'label+percent'
      },
    ],
    layout: {
      legend: {orientation: 'v', y: 1, x: 1.5, xanchor: 'center'},
      margin: {r: 200, l: 0, t: 10, b: 15},
      uniformtext: {
        mode: 'hide',
        minsize: 10
      },
      height: 300,
      autosize: true,

    },
    config: {
      displayModeBar: false,
      //staticPlot: this.common.isMobile()
    },
  };

  @HostListener('window:resize')
  onResize() {
    if (this.plotlyChart && this.plotContainer?.nativeElement) {
      const container = this.plotContainer.nativeElement.getBoundingClientRect();
      Plotly.relayout(this.plotlyChart, {width: container.width});
    }
  }

  ngOnInit() {
    this.plotId = `#plot${this.data[0].sqa_chart_id}`

    this.chartData.data[0].labels = this.data[0].labels
    this.chartData.data[0].values = this.data[0].values
  }


  ngAfterViewInit() {
    // console.log(this.plotContainer.nativeElement.id);
    if (this.plotContainer?.nativeElement) {
      Plotly.newPlot(this.plotContainer.nativeElement, this.chartData.data, this.chartData.layout, this.chartData.config)
        .then((chart) => {
          this.plotlyChart = chart;
          this.originalChart = this.common.removeCircularReferences(this.plotlyChart);
          this.chartContainer.nativeElement = chart
        })
        .catch((error) => {
          console.error('Error rendering chart:', error);
        });
    } else {
      console.error('Chart container is not available in ngAfterViewInit.');
    }
  }


}
